import { Button as BaseButton } from '@base-ui/react/button';

const Button = ({
    children,
    variant = 'primary',
    size = 'md',
    disabled = false,
    loading = false,
    onClick,
    type = 'button',
    className = '',
    ...props
}) => {
    const baseClasses =
        'font-medium rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2';

    const variants = {
        // Primary: preto no tema claro, branco no tema escuro
        primary:
            'bg-black dark:bg-white text-white dark:text-black hover:bg-mono-800 dark:hover:bg-mono-100 active:bg-mono-700 dark:active:bg-mono-200 focus:ring-mono-500 disabled:bg-mono-300 dark:disabled:bg-mono-700',

        // Secondary: cinza medio com borda
        secondary:
            'bg-white dark:bg-black text-black dark:text-white border border-mono-300 dark:border-mono-700 hover:bg-mono-50 dark:hover:bg-mono-950 active:bg-mono-100 dark:active:bg-mono-900 focus:ring-mono-500 disabled:bg-mono-100 dark:disabled:bg-mono-900',

        // Ghost: transparente
        ghost: 'bg-transparent text-black dark:text-white hover:bg-mono-100 dark:hover:bg-mono-900 active:bg-mono-200 dark:active:bg-mono-800 focus:ring-mono-500 disabled:text-mono-400 dark:disabled:text-mono-600',

        // Danger: acoes destrutivas (token semantico `danger` do tailwind.config.js)
        danger: 'bg-danger-600 text-white hover:bg-danger-700 active:bg-danger-800 focus:ring-danger-500 disabled:bg-danger-300 dark:disabled:bg-danger-900',

        // Success: concluir (ex.: "Finalizar OP" da bancada)
        success:
            'bg-success-600 text-white hover:bg-success-700 active:bg-success-800 focus:ring-success-500 disabled:bg-success-300 dark:disabled:bg-success-900',

        // Info: interromper sem encerrar (ex.: "Pausar OP" da bancada)
        info: 'bg-info-600 text-white hover:bg-info-700 active:bg-info-800 focus:ring-info-500 disabled:bg-info-300 dark:disabled:bg-info-900',
    };

    // `pointer-coarse:` garante alvo de toque >=44px em dispositivos de toque
    // sem inflar o visual desktop (sm ~30px e md ~40px de altura com mouse).
    const sizes = {
        sm: 'px-3 py-1.5 text-sm pointer-coarse:min-h-11 pointer-coarse:min-w-11',
        md: 'px-4 py-2 text-base pointer-coarse:min-h-11 pointer-coarse:min-w-11',
        lg: 'px-6 py-3 text-lg',
    };

    return (
        <BaseButton
            type={type}
            disabled={disabled || loading}
            onClick={onClick}
            className={`flex items-center justify-center ${baseClasses} ${variants[variant]} ${sizes[size]} ${disabled || loading ? 'cursor-not-allowed opacity-50' : ''} ${className}`}
            {...props}
        >
            {loading ? (
                <>
                    <svg
                        className="animate-spin -ml-1 mr-2 h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <title>Loading</title>
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                        <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        />
                    </svg>
                    {children}
                </>
            ) : (
                children
            )}
        </BaseButton>
    );
};

export default Button;
